import React from "react";
import { Navigate } from "react-router-dom";

import { CLIENT_HOME_PATH } from "@/constants/navigation";
import { useClientPlatformAccess } from "@/hooks/useClientPlatformAccess";

/**
 * The API keys routes follow the nav: without the API Access level a direct
 * URL lands on the console home instead, as the Distributor section's do
 * (DistributorRoute). yaas-api refuses the key routes without it too.
 * OnboardingGate has already settled context discovery before a shell route
 * renders.
 */
export function ApiAccessRoute({
    children
}: {
    children: React.ReactNode;
}): React.ReactElement {
    const { apiAccess } = useClientPlatformAccess();
    if (!apiAccess) return <Navigate to={CLIENT_HOME_PATH} replace />;
    return <>{children}</>;
}

/** A route component wrapped in `ApiAccessRoute`. */
export function apiAccessOnly(Page: React.ComponentType): React.ComponentType {
    function ApiAccessOnlyPage(): React.ReactElement {
        return (
            <ApiAccessRoute>
                <Page />
            </ApiAccessRoute>
        );
    }
    ApiAccessOnlyPage.displayName = `ApiAccessOnly(${Page.displayName ?? Page.name})`;
    return ApiAccessOnlyPage;
}
